var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,98.1l48.7-80.5C84.7,7,67.6,1.1,50,1C32.4,1.1,15.3,7,1.3,17.6L50,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100L0,17.4l0.8-0.6C14.9,6,32.2,0.1,50,0c17.8,0.1,35.1,6,49.2,16.8l0.8,0.6l-0.5,0.9L50,100z M2.6,18L50,96.3 l47.3-78.4C83.6,7.7,67,2.1,49.9,2.1C32.9,2.2,16.3,7.7,2.6,18L2.6,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO01);
export default __webpack_public_path__ + "static/media/O_01.1c8b014c9650453108b2b82ecb772b8c.svg";
export { ForwardRef as ReactComponent };